<template>
  <v-card color_="blue-grey darken-2" class_="white--text" class="elevation-2">
    <v-card-title primary-title class_="blue-grey darken-2">
      <div>
        <div class="subtitle-1 font-weight-medium mb-2">
          Relatório de Vendas
        </div>
        <div class="body-2">Relação das vendas efetuadas no período.</div>
      </div>
    </v-card-title>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn depressed color="primary" @click="abrir">Opções</v-btn>
    </v-card-actions>
    <v-divider v-show="aberto"></v-divider>
    <!-- <v-expand-transition> -->
    <!-- <v-card-text v-show="aberto" class="white"> -->
    <z-dialogo ref="dialogo" titulo="RELATÓRIO DE VENDAS" largura="500px" persistent>
      <template v-slot:texto>
        <v-row dense>
          <v-col sm="12">
            <v-autocomplete filled dense v-model="filtro.cliente_id" label="Cliente"
              :items="$store.state.listas.clientes" clearable></v-autocomplete>
          </v-col>

          <v-col cols="12">
            <v-autocomplete
              v-model="filtro.vendedor_id"
              filled dense 
              clearable
              label="Vendedor"
              :items="$store.state.listas.vendedores"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col>
            <z-date-picker-menu filled dense label="Data Inicial" v-model="filtro.data_inicial"></z-date-picker-menu>
          </v-col>
          <v-col>
            <z-date-picker-menu filled dense label="Data Final" v-model="filtro.data_final"></z-date-picker-menu>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col sm="12">
            <v-select filled dense :items="$globals.FORMAS_DE_PAGAMENTO_CAIXA" label="Forma de Pagamento" placeholder=" "
              v-model="filtro.forma_pagamento" clearable></v-select>
          </v-col>
          <v-col sm="12">
            <v-select filled dense :items="['Em Aberto', 'Pago']" label="Situação" v-model="filtro.situacao"
              clearable></v-select>
          </v-col>
        </v-row>
      </template>
      <template v-slot:actions_right>
        <v-spacer></v-spacer>
        <v-btn text @click="$refs.dialogo.fechar()">Cancelar</v-btn>
        <v-btn depressed color="primary" @click="imprimir">Imprimir</v-btn>
      </template>
    </z-dialogo>
    <!-- </v-card-text> -->
    <!-- </v-expand-transition> -->
  </v-card>
</template>

<script>
import { parseParams } from '@/app/helpers/utils'

export default {
  data() {
    return {
      aberto: false,
      filtro: {
        data_inicial: this.$moment().format("YYYY-MM-DD"),
        data_final: this.$moment().format("YYYY-MM-DD"),
      }
    };
  },

  inject: ["$imprimir"],

  methods: {
    async abrir() {
      this.$refs.dialogo.abrir();
    },

    imprimir() {
      this.$imprimir("relatorios/vendas?" + new URLSearchParams(parseParams(this.filtro)).toString(), "relatorio_de_vendas.pdf");
    },
  },
};
</script>

<style scoped></style>
